import Link from '@uilib/business-components/Link';

import i18n from 'Services/i18n';

export default function LinkWrapper(props) {
    return <Link className="ui-fix-link" {...props} text={i18n(props.text)} testDataLabel="eid-link-wrapper" />;
}
